import styled from "styled-components";

export const TooltipHeader = styled.p`
    margin: 0 0 8px 0;
`

export const Position = styled.div`
    display: flex;
    align-content: center;
    gap: 6px;
    margin-bottom: 6px;
`